export default __webpack_public_path__ + "static/new-insulin__core-360-paid-04-1995de84400838d7501966e2f3eb3088.jpg";